import React from "react";
import { useLeaderboard } from "../shared/assets/useLeaderboard";

function Header() {
    const { lastUpdated, loading } = useLeaderboard();

    const subtitle = loading || !lastUpdated
        ? "Loading..."
        : `Last updated: ${new Date(lastUpdated).toLocaleString()}`;

    return (
        <div className="bg-black bg-opacity-30">
            <p className="text-5xl pt-10 masters-label">2026 Masters Pool</p>
            <p className="text-2xl pb-10 masters-label">( Official Final Results )</p>
        </div>
    );
};

export default Header;